import React, { useState, useEffect, Fragment } from 'react';
import { AxiosAPI, getGroupID, AxiosStripeAPI, getUserID } from '../../../../../helpers/AxiosAPI';
import { gAPI_Subscription_By_Group_Id } from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
function Index({ propertyId }) {
    useEffect(() => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Subscription_By_Group_Id}?groupid=${getGroupID()}`,
        })
            .then(subscriptionResponse => {
                //console.log(subscriptionResponse.data)
                if (subscriptionResponse.data.stripeCustomerId === null || subscriptionResponse.data.stripeCustomerId === '') {
                    setError(true)
                }
                else {
                    StripeCustmerPortal(subscriptionResponse.data.stripeCustomerId)
                }
            });
    }, [propertyId]);
    const [error, setError] = useState(false);
    const StripeCustmerPortal = (customerID) => {
        var qs = require('qs');
        var data = qs.stringify({
            'customer': customerID,
            'return_url': window.location.href
        });
        AxiosStripeAPI({
            method: 'post',
            url: `v1/billing_portal/sessions`,
            data: data
        })
            .then(stripeResponse => {
                window.location.href = stripeResponse.data.url;
            });
    };

    return (<Fragment>
        {error === true && (<p>
            Please subscribe to subscription first.
        </p>)}
    </Fragment>);
}
const mapStateToProps = ({ settings }) => {
    const { propertyId } = settings;
    return {
        propertyId,
    };
};

export default injectIntl(connect(mapStateToProps, {})(Index));